// SignIn.jsx
import React, { useState } from 'react';
import './Pages/PagesCss/Auth.css';
import { useNavigate } from 'react-router-dom';
import logo from './assets/logo.png';

const SignIn = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!form.email) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) newErrors.email = 'Enter a valid email';
    if (!form.password) newErrors.password = 'Password is required';
    else if (form.password.length < 6) newErrors.password = 'Min 6 characters';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    // TODO: handle sign-in logic
    console.log('Sign In:', form, 'Remember:', rememberMe);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  return (
    <div className="auth-page">
      {/* Left Panel */}
      <div className="auth-panel auth-panel--left">
        <div className="auth-panel__inner">
          <div className="auth-brand" onClick={() => navigate('/')}>
            <img src={logo} alt="QuickPDFs" className="auth-logo" />
            <span className="auth-brand-name"><span className="highlight">Quick</span>PDFs.net</span>
          </div>
          <div className="auth-panel__copy">
            <h2 className="auth-panel__headline">
              All your PDF tools,<br />one powerful place.
            </h2>
            <p className="auth-panel__sub">
              Sign in to access 26+ free PDF tools merge, split, convert, compress and more.
            </p>
            <ul className="auth-features">
              <li><span className="auth-feature-dot" />100% Free  Always</li>
              <li><span className="auth-feature-dot" />Files auto-deleted after processing</li>
              <li><span className="auth-feature-dot" />Works on any device, any browser</li>
              <li><span className="auth-feature-dot" />No watermarks, no limits</li>
            </ul>
          </div>
          <div className="auth-panel__stats">
            <div className="auth-stat"><span className="auth-stat-num">26+</span><span className="auth-stat-label">PDF Tools</span></div>
            <div className="auth-stat"><span className="auth-stat-num">5M+</span><span className="auth-stat-label">Files Processed</span></div>
            <div className="auth-stat"><span className="auth-stat-num">99%</span><span className="auth-stat-label">Uptime</span></div>
          </div>
        </div>
      </div>

      {/* Right Panel Form */}
      <div className="auth-panel auth-panel--right">
        <div className="auth-form-wrap">
          <div className="auth-form-header">
            <h1 className="auth-form-title">Welcome back</h1>
            <p className="auth-form-sub">Sign in to your QuickPDFs account</p>
          </div>

          {/* Social Buttons */}
          <div className="auth-social">
            <button className="auth-social-btn" type="button">
              {/* Google Icon */}
              <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              Continue with Google
            </button>
            <button className="auth-social-btn" type="button">
              {/* Apple Icon */}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.43c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.39-1.32 2.76-2.53 3.96zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>
              Continue with Apple
            </button>
          </div>

          <div className="auth-divider"><span>or sign in with email</span></div>

          {/* Form */}
          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            <div className={`auth-field ${errors.email ? 'auth-field--error' : ''}`}>
              <label className="auth-label" htmlFor="signin-email">Email address</label>
              <input
                id="signin-email"
                className="auth-input"
                type="email"
                name="email"
                placeholder="you@example.com"
                value={form.email}
                onChange={handleChange}
                autoComplete="email"
              />
              {errors.email && <span className="auth-error-msg">{errors.email}</span>}
            </div>

            <div className={`auth-field ${errors.password ? 'auth-field--error' : ''}`}>
              <div className="auth-label-row">
                <label className="auth-label" htmlFor="signin-password">Password</label>
                <a href="/forgot-password" className="auth-forgot">Forgot password?</a>
              </div>
              <div className="auth-input-wrap">
                <input
                  id="signin-password"
                  className="auth-input"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="••••••••"
                  value={form.password}
                  onChange={handleChange}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="auth-eye-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label="Toggle password"
                >
                  {showPassword ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
              {errors.password && <span className="auth-error-msg">{errors.password}</span>}
            </div>

            {/* Remember Me */}
            <div className="auth-check-row">
              <label className="auth-checkbox-label">
                <input
                  type="checkbox"
                  className="auth-checkbox-input"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                />
                <span className="auth-checkbox-custom" />
                <span className="auth-checkbox-text">Remember me for 30 days</span>
              </label>
            </div>

            <button className="auth-submit-btn" type="submit">
              Sign In
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>
          </form>

          <p className="auth-switch">
            Don't have an account?{' '}
            <span className="auth-switch-link" onClick={() => navigate('/signup')}>
              Create one free →
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignIn;